import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { Calendar, Phone } from 'lucide-react';
import { BUSINESS } from '../../lib/data';

// Sticky bottom booking bar on phones — appears once the hero CTA has scrolled away.
export default function MobileCta() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 640);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 90, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 90, opacity: 0 }}
          transition={{ type: 'spring', damping: 24, stiffness: 260 }}
          className="fixed bottom-4 inset-x-4 z-40 lg:hidden"
        >
          <div className="flex items-center gap-2.5 bg-white/85 backdrop-blur-xl rounded-full shadow-2xl shadow-purple-300/40 border border-white p-2">
            <Link
              to="/booking"
              className="btn-shine flex-1 inline-flex items-center justify-center space-x-2 bg-gradient-to-r from-pink-500 to-cyan-500 text-white px-5 py-3.5 rounded-full font-extrabold text-[15px]"
            >
              <Calendar className="w-4 h-4" />
              <span>Book a Spa Day</span>
            </Link>
            <a
              href={BUSINESS.phoneHref}
              aria-label="Call us"
              className="p-3.5 rounded-full bg-ink-900 text-white shadow-lg"
            >
              <Phone className="w-5 h-5" />
            </a>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
